import api from '@/services/api/api';
import exceptionHandler from '@/services/exceptions';
import PermissionGroupData from '@/types/PermissionGroup/PermissionGroupData';
import { useQuery } from '@tanstack/react-query';

export const useGetPermissionGroupQuery = (id: string) => {
  return useQuery({
    queryKey: [`admin/group/${id}`, id],
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!id,
    queryFn: async () => {
      try {
        if (!id) return null;
        const response = await api.get<PermissionGroupData>(`admin/group/${id}`);
        return response.data;
      } catch (err) {
        exceptionHandler(err);
        return null;
      }
    },
  });
};
